<template>
  <div id="proile-settings">
    <b-card class="m-b-3">
      <h5>Параметры доступа</h5>
      <div v-if="phone" class="m-b-1">
        Номер телефона: {{ phone }}
        <b-button v-if="1 !== 1" v-b-modal.phone_change size="sm" variant="primary">Изменить</b-button>
      </div>
      <div v-else>
        У вас не прикреплен номер телефона. Введите номер телефона что бы прикрепить его к учетной записи.
        <b-button v-b-modal.phone_change variant="primary">Прикрепить</b-button>
      </div>
      <b-modal centered id="phone_change" ref="phone_change" title="Изменить номер телефона">
        <b-form v-on:submit.prevent="onSubmit" id="profile-form">
          <b-form-group id="phoneInputGroup" label="Номер телефона:" label-for="phone">
            <vue-tel-input
              id="new_phone"
              v-model="new_phone"
              placeholder="Введите номер телефона"
              :preferredCountries="['ru', 'us', 'gb', 'ua']"
            />
            <div class="text-danger" v-show="errors['phone']">{{ errors["phone"] }}</div>
          </b-form-group>
          <b-button v-on:click="send_key()" size="sm" variant="primary">Получить код подтверждения</b-button>
          <div v-if="key_sent" class="m-t-3">
            <b-form-group
              id="phoneInputGroup"
              label="Код подтверждения выслан на указанный вами номер телефона"
              label-for="secret_key"
            >
              <b-form-input
                id="secret_key"
                type="text"
                v-model="secret_key"
                required
                placeholder="Введите код подтверждения"
              >
              </b-form-input>
              <b-button v-on:click="change_phone()" class="m-t-3" variant="success">Подтвердить</b-button>
            </b-form-group>
            <div class="text-danger" v-show="errors['phone']">{{ errors["phone"] }}</div>
          </div>
        </b-form>
        <div slot="modal-footer"></div>
      </b-modal>
    </b-card>
    <b-card>
      <h5>Изменить пароль</h5>
      <b-form v-on:submit.prevent="change_password">
        <b-form-group id="old_passwordInputGroup" label="Введите старый пароль:" label-for="old_password">
          <b-form-input id="old_password" type="password" v-model="old_password" required placeholder="Старый пароль">
          </b-form-input>
        </b-form-group>
        <b-form-group id="passwordInputGroup" label="Введите новый пароль:" label-for="password">
          <b-form-input id="password" type="password" v-model="password" required placeholder="Новый пароль">
          </b-form-input>
        </b-form-group>
        <b-form-group id="password2InputGroup" label="Введите новый пароль ещё раз:" label-for="password2">
          <b-form-input id="password2" type="password" v-model="password2" required placeholder="Новый пароль ещё раз">
          </b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Изменить</b-button>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import "vue-tel-input/dist/vue-tel-input.css";
import VueTelInput from "vue-tel-input";
export default {
  name: "profile-settings",
  components: { VueTelInput },
  data() {
    return {
      phone: "",
      email: "",
      password: "",
      password2: "",
      old_password: "",
      new_phone: "",
      secret_key: "",
      key_sent: false,
      errors: {},
    };
  },
  methods: {
    change_password() {
      if (this.password !== this.password2) {
        alert("Введенные пароли не совпадают");
        return false;
      }
      this.$http
        .get("user/change-password", {
          params: {
            old_password: this.old_password,
            new_password: this.password,
          },
        })
        .then((response) => {
          alert(response.data);
        })
        .catch((e) => {
          alert(e.response.data);
        });
    },
    change_phone() {
      this.$http
        .get("user/set-phone", {
          params: {
            key: this.secret_key,
            phone: this.new_phone,
          },
        })
        .then((response) => {
          this.phone = this.new_phone;
          this.$auth.user().license.push(response.data);
          this.$refs.phone_change.hide();
        })
        .catch((e) => {
          alert(e.response.data);
        });
    },
    send_key() {
      this.$http
        .get("user/get-secret", {
          params: {
            phone: this.new_phone,
          },
        })
        .then((response) => {
          alert(response.data);
          this.key_sent = true;
        });
    },
    fetchData() {
      this.$http.get("user/security").then((response) => {
        this.phone = response.data.phone;
        this.email = response.data.email;
      });
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
